import {DetailedHTMLProps, AnchorHTMLAttributes, ReactNode} from 'react';
import styles from './styles.module.css';
import cn from 'clsx';
import {CustomIcon} from '@guestapp/ui';

type HomeSectionProps = {
  className?: string;
  children: ReactNode;
  noArrow?: boolean;
};
export const HomeSection = ({className, children}: HomeSectionProps) => {
  return <div className={cn(styles.HomeSection, className)}>{children}</div>;
};

export const HomeSectionLink = ({
  className,
  children,
  noArrow,
  ...props
}: HomeSectionProps &
  DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) => {
  return (
    <a className={cn(styles.HomeSectionLink, className)} {...props}>
      <HomeSection className={styles.HomeSectionLink__content}>{children}</HomeSection>
      {!noArrow && (
        <CustomIcon
          containerClassName={styles.HomeSectionLink__icon}
          className="HomeSectionLink__icon"
          name="grayRightArrow"
          size={16}
          color="transparent"
        />
      )}
    </a>
  );
};

type HomeSectionHeaderProps = {
  className?: string;
  title: ReactNode;
  subtitle?: ReactNode;
};
export const HomeSectionHeader = ({
  className,
  title,
  subtitle,
}: HomeSectionHeaderProps) => {
  return (
    <div className={cn(className, styles.HomeSectionHeader)}>
      <div className={styles.HomeSectionHeader__title}>{title}</div>
      <div className={styles.HomeSectionHeader__subtitle}>{subtitle}</div>
    </div>
  );
};
